import TabGroup from "@eisinc/MobiusOverrides/TabGroup/TabGroup";

export default TabGroup;

export * from "@eisinc/MobiusOverrides/TabGroup/TabGroup";
